import { render, staticRenderFns } from "./UnarchiveItemAction.vue?vue&type=template&id=f10b81c2&"
import script from "./UnarchiveItemAction.vue?vue&type=script&lang=js&"
export * from "./UnarchiveItemAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports